module.exports = __webpack_public_path__ + "img/grand-f1c.0409292d.png";